import { render, staticRenderFns } from "./Gradients.vue?vue&type=template&id=733beb84&"
import script from "./Gradients.vue?vue&type=script&lang=js&"
export * from "./Gradients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports